import { type StatefulDevice } from '@daily-co/daily-react';

/**
 * A simple store to provide access to enabled camera and microphone devices.
 * It also allows components or hooks to subscribe to changes
 */
class DeviceStore {
  private enabledCam: StatefulDevice | undefined = undefined;
  private enabledMic: StatefulDevice | undefined = undefined;
  private listeners = new Set<() => void>();

  getEnabledCam = () => this.enabledCam;
  getEnabledMic = () => this.enabledMic;

  setEnabledCam = (device: StatefulDevice | undefined) => {
    this.enabledCam = device;
    this.notifyListeners();
  };

  setEnabledMic = (device: StatefulDevice | undefined) => {
    this.enabledMic = device;
    this.notifyListeners();
  };

  subscribe = (listener: () => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  private notifyListeners = () => {
    this.listeners.forEach((listener) => listener());
  };
}

const deviceStore = new DeviceStore();

export default deviceStore;
